import AnimatedOutlet from '@/components/AnimatedOutlet';
import AlertTicker from '@/components/home/AlertTicker';
import Header from './Header';
import Footer from './Footer';
import { ToastProvider } from '@/components/ui/Toast';

export default function Layout() {
  return (
    <ToastProvider>
      {/* AlertTicker: fixed 28px bar at top-0, z-50 */}
      <AlertTicker />

      <div className="flex min-h-screen flex-col bg-bg-900 pt-7">
        {/* Header is sticky top-0 within this offset container */}
        <Header />
        <main id="main-content" className="flex-1">
          <AnimatedOutlet />
        </main>
        <Footer />
      </div>
    </ToastProvider>
  );
}
